/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { Auth } from 'app/scripts/db/auth';
import { LargeAvatarView } from 'app/scripts/views/member-menu-profile/LargeAvatarView';
import { ModelLoader } from 'app/scripts/db/model-loader';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { PopOver } from 'app/scripts/views/lib/pop-over';
import { View } from 'app/scripts/views/internal/view';
import _ from 'underscore';
import template from 'app/scripts/views/templates/mini_profile';
import { Analytics } from '@trello/atlassian-analytics';

class MemberMiniProfileView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'member';
    this.prototype.displayType = 'mod-mini-profile';
  }

  initialize() {
    super.initialize(...arguments);
    this.listenTo(
      this.model,
      'change change:avatarUrl change:avatarSource',
      this.frameDebounce(this.render),
    );
  }

  delegateEvents(events) {
    const miniprofileEvents = {
      'click .js-profile': 'showProfile',
      'click .js-view-large': 'viewLarge',
    };

    return super.delegateEvents(
      _.extend(miniprofileEvents, events || this.events),
    );
  }

  render() {
    const data = this.model.toJSON();
    data.isMe = Auth.isMe(this.model);
    data.showEmail = data.email != null && !data.isMe;
    data.isDeactivated = this.options?.board?.isDeactivated(this.model);

    if (
      data.email == null &&
      this.model.get('memberType') === 'ghost' &&
      !this.loaded
    ) {
      this.loadEmail();
    }

    // render mini-profile
    this.$el.html(template(data));

    // render menu options
    this.renderMenu();

    return this;
  }

  renderMenu() {}

  loadEmail() {
    return ModelLoader.loadMemberEmail(this.model.id)
      .then(() => {
        return (this.loaded = true);
      })
      .done();
  }

  showProfile() {
    Analytics.sendClickedLinkEvent({
      linkName: 'fullNameProfileLink',
      source: 'miniProfileInlineDialog',
    });
  }

  viewLarge(e) {
    stopPropagationAndPreventDefault(e);

    Analytics.sendUIEvent({
      action: 'clicked',
      actionSubject: 'avatar',
      actionSubjectId: 'miniProfileAvatar',
      source: 'miniProfileInlineDialog',
    });

    PopOver.pushView({
      elem: this.$(e.target),
      view: new LargeAvatarView({
        model: this.model,
        modelCache: this.modelCache,
      }),
    });
  }
}

MemberMiniProfileView.initClass();
export { MemberMiniProfileView };
